// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";

import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";




const blogs = [
    {
        id: '1',
        title: 'Tips for Orthopedic Surgery Patients',
        title2: 'How Do Your Emotions Affect Your Physical Health?',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg1,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio corporis, libero,',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Transfusion strategy and heart surgery',
        title2: 'Preserving Care Strategy Amidst Food Changes',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg2,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio corporis, libero,',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'Get the Exercise for Limited Mobility',
        title2: 'What Mutations Of SARS-CoV-2 Are Causing Concern?.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy',
        screens: blogImg3,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio corporis, libero,',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    


];
export default blogs;



